// Stock, as the shopper sees it — the ONE place the storefront decides
// "in stock", "only N left" and the quantity ceiling.
//
// The API is changing (2026-10-17, PR B): public products stop carrying the
// exact stock_count and send instead
//   availability:    "in_stock" | "out_of_stock"
//   low_stock_count: 1..5, only when the stock is real (entered by an admin
//                    or seller), otherwise null.
// These helpers read the new fields when present and fall back to
// stock_count when not, so the site behaves the same against the API before
// and after that release. Once the release is live everywhere the fallback
// can go.

export const LOW_STOCK_MAX = 5;
// The server caps one cart line at 5 (CartItemCreate.qty le=5).
export const MAX_QTY_PER_LINE = 5;

const hasNewFields = (p) => p != null && typeof p.availability === "string";

export function isInStock(p) {
  if (!p) return false;
  if (hasNewFields(p)) return p.availability === "in_stock";
  return (p.stock_count ?? 0) > 0;
}

// The number to show as "Only N left", or null for no low-stock message.
export function lowStockCount(p) {
  if (!p) return null;
  if (hasNewFields(p)) return p.low_stock_count ?? null;
  const n = p.stock_count;
  return n > 0 && n <= LOW_STOCK_MAX ? n : null;
}

// The highest quantity a shopper may pick on the product page.
export function maxQuantity(p) {
  if (!isInStock(p)) return 0;
  if (hasNewFields(p)) return lowStockCount(p) ?? MAX_QTY_PER_LINE;
  return p.stock_count; // old API: unchanged behaviour
}
